.container {
  flex: 1;
  height: 100%;
  background-color: #1e1e1e; /* Dark theme canvas */
  overflow: hidden;
  position: relative;
  cursor: grab;
  user-select: none;
  -webkit-user-select: none;
}

.container:active {
  cursor: grabbing;
}

.containerDrawing {
  cursor: crosshair !important;
}

.svg {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  /* Will-change for performance pan/zoom */
  will-change: transform;
  user-select: none;
  -webkit-user-select: none;
}

.activeToolBanner {
  position: absolute;
  top: 16px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 16px;
  background: rgba(15, 23, 42, 0.88);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  border: 1px solid rgba(56, 189, 248, 0.4);
  border-radius: 20px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.5), 0 0 12px rgba(56, 189, 248, 0.2);
  color: #f1f5f9;
  font-size: 13px;
  z-index: 100;
  pointer-events: auto;
  user-select: none;
  animation: fadeIn 0.2s ease-out;
}

.activeToolBadge {
  background: #0284c7;
  color: #fff;
  padding: 2px 8px;
  border-radius: 12px;
  font-weight: 600;
  font-size: 11px;
}

.activeToolHint {
  color: #94a3b8;
  font-size: 12px;
}

.activeToolClose {
  background: none;
  border: none;
  color: #94a3b8;
  cursor: pointer;
  font-size: 16px;
  line-height: 1;
  padding: 2px 6px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: color 0.15s, background-color 0.15s;
}

.activeToolClose:hover {
  color: #fff;
  background: rgba(255, 255, 255, 0.1);
}

@keyframes fadeIn {
  from { opacity: 0; transform: translate(-50%, -8px); }
  to { opacity: 1; transform: translate(-50%, 0); }
}
